export default "__VITE_ASSET__DjvfCbPY__"